import { Dispatch, memo, SetStateAction } from "react";
import CheckboxInput from "../../../components/inputs/CheckboxInput";
import { useTranslation } from "react-i18next";
import { useGetLocationsWithBuildings } from "../../../hooks/common/query";

interface AreaAccessCardProps {
    checkedBuildingIds: number[];
    setCheckedBuildingIds: Dispatch<SetStateAction<number[]>>;
    isFieldsDisabled?: boolean;
}

const AreaAccessCard = ({
    checkedBuildingIds,
    setCheckedBuildingIds,
    isFieldsDisabled
}: AreaAccessCardProps) => {
    const { t, i18n } = useTranslation();

    const { data: locationsWithBuildings } = useGetLocationsWithBuildings();

    return (
        <div className="flex flex-col gap-1">
            <p className="font-medium">
                {t("areaAccess")}
            </p>

            {locationsWithBuildings?.map((item: any, idx: number) => {
                if (item.buildings.length === 0) return null;

                return (
                    <div key={idx} className="flex flex-col gap-3 mb-3 last:mb-0">
                        <p className="font-semibold text-sm">
                            {i18n.language === "en"
                                ? item.s_LocationName_En
                                : item.s_LocationName_Ar}
                        </p>

                        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                            {item.buildings?.map((building: any) => {
                                // Use n_BuildingID if present, otherwise fallback to n_Building
                                const buildingId = building.n_BuildingID ?? building.n_Building;
                                const isChecked = checkedBuildingIds.includes(buildingId);

                                return (
                                    <div key={buildingId}>
                                        <CheckboxInput
                                            key={`building-${buildingId}`}
                                            id={`building-${buildingId}`}
                                            label={i18n.language === "en" ? building.s_BuildingName_En : building.s_BuildingName_Ar}
                                            checked={isChecked}
                                            setChecked={() => {
                                                setCheckedBuildingIds(prev =>
                                                    isChecked
                                                        ? prev.filter(id => id !== buildingId)
                                                        : [...prev, buildingId]
                                                );
                                            }}
                                            readOnly={isFieldsDisabled}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    )
}

export default memo(AreaAccessCard)
